import styled, { css } from 'styled-components';
import Dropzone from 'react-dropzone';

export const OverlayWrap = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: ${({ theme }) => theme.palette.global01}EE;

  display: flex;
  justify-content: center;
  align-items: center;
  pointer-events: none;
  ${({ isActive }) =>
    isActive
      ? css`
          opacity: 1;
          z-index: 9999;
        `
      : css`
          opacity: 0;
          z-index: 1;
        `};

  transition: opacity 0.3s;
`;

export const DropPlaceHolder = styled.div`
  border: 2px dashed ${({ theme }) => theme.palette.global02};
  display: flex;
  justify-content: center;
  align-items: center;
  height: calc(100% - 72px);
  width: calc(100% - 72px);
  ${({ theme }) => theme.textStyles.heading01global02};
`;

export const DropZoneStyled = styled(Dropzone)`
  position: relative;
  width: 100vw;
  height: 100vh;
  z-index: 20;
`;

export default null;



// WEBPACK FOOTER //
// /opt/build/repo/src/app/components/ImageDrop/ImageDrop.styled.js